import { Box, Grid, Image } from "atoms";
import React from "react";
import HouseImage from "assets/img/house.png";
import Logo from "assets/img/logo.svg";

const AuthLayout = ({ children }) => {
  return (
    <Grid gridTemplateColumns={{ lg: "1fr 1fr" }} height="100vh">
      <Grid bg="primary.900" placeItems="center">
        <Image src={Logo} objectFit="contain" width="46rem" mx="auto" />
      </Grid>
      <Grid bg="white">
        <Box>{children}</Box>
      </Grid>
      <Box position="absolute" bottom="-2px">
        <Image src={HouseImage} objectFit="contain" />
      </Box>
    </Grid>
  );
};

export default AuthLayout;
